import { useLingui } from "@lingui/react/macro";
import { useMemo } from "react";

import { assetName } from "../lib/assetName";
import { useAssets } from "./useAssets";

export type HeroView = {
  id: number;
  // Английское название (`assetName`).
  name: string;
  // Названия на всех языках: по ним ищет выбор героев.
  aliases: string[];
  iconUrl: string | null;
  // Фоновый арт (обложка профиля) и фирменный цвет `#RRGGBB`.
  backgroundUrl: string | null;
  color: string | null;
};

// Герой по id из справочника. Нет в справочнике — «Герой #id» без иконки, арта и цвета.
export const useHeroLookup = (): ((id: number) => HeroView) => {
  const { t } = useLingui();
  const { data } = useAssets();
  const heroes = useMemo(
    () => new Map((data?.heroes ?? []).map((hero) => [hero.id, hero])),
    [data],
  );
  return (heroId: number) => {
    const hero = heroes.get(heroId);
    if (hero === undefined) {
      const name = t`Hero #${heroId}`;
      return { id: heroId, name, aliases: [name], iconUrl: null, backgroundUrl: null, color: null };
    }
    return {
      id: heroId,
      name: assetName(hero.name),
      aliases: [hero.name.en, hero.name.ru],
      iconUrl: hero.icon_url,
      backgroundUrl: hero.background_url,
      color: hero.color,
    };
  };
};
